const brlFormatter = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL'
});

/** Formats a numeric value as BRL (same semantics as previous inline Intl usage). */
export function formatCurrencyBRL(price) {
  return brlFormatter.format(price);
}

/** License purchase summary: null price means "Sob consulta". */
export function formatLicensePriceOrConsult(price) {
  if (price === null) return 'Sob consulta';
  return formatCurrencyBRL(price);
}
